export const LADE_AUSWAHLWERTE_SUBVENTION_BEITRAG = "ladeAuswahlwerteSubventionBeitrag";